var _style, _linearGradient;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRadiusAnimation = function SvgRadiusAnimation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: ref
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes stroke{0%{transform:rotate(-360deg);transform-origin:center}to{transform:rotate(360deg);transform-origin:center}}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "0%",
    x2: "0%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#162929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "10%",
    stopColor: "#1f4f4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "25%",
    stopColor: "#33eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    stopColor: "#1f4f4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#162929"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 45,
    fill: "transparent",
    stroke: "url(#g)",
    strokeDasharray: 300,
    strokeWidth: 3,
    className: "circle",
    style: {
      animation: "stroke 5s infinite linear"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRadiusAnimation);
export default ForwardRef;